import { render, staticRenderFns } from "./Passolution.vue?vue&type=template&id=00da617a&scoped=true"
import script from "./Passolution.vue?vue&type=script&lang=js"
export * from "./Passolution.vue?vue&type=script&lang=js"
import style0 from "./Passolution.vue?vue&type=style&index=0&id=00da617a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00da617a",
  null
  
)

export default component.exports